<template>
  <custom-dialog v-drag-dialog :title="model.title" :visible="visible" v-on="$listeners" width="80%" class="rework-item-dialog">
    <div class="dialog-body">
      <!-- 表单 -->
      <div class="item-title">{{ $t('asm_rework_dialog.ji_chu_xin_xi') }}</div>
      <el-form :disabled="model.type == 'watch'" :model="form" :inline="true" ref="form" label-position="top" :rules="rules">
        <el-row>
          <el-col :span="8">
            <el-form-item :label="$t('asm_rework_dialog.chan_pinSN')" prop="productSn">
              <custom-select
                :filterable="true"
                key="ProductModelList"
                url="ProductModelList"
                v-model="form.productSn"
                :placeholder="$t('Common.com_please_select')"
                :model="form"
                :props="{ label: 'codeSn', value: 'productSn', map: { productCode: 'productCode' } }"
                @change="onChangeProduct"
                width="100%"
              ></custom-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="1">
            <el-form-item :label="$t('asm_rework_dialog.ban_ben_hao')" prop="itemVersion">
              <el-input placeholder="" v-model="form.itemVersion"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('asm_rework_dialog.ban_ben_miao_shu')" prop="groupDesc">
              <el-input type="textarea" :rows="3" :max="200" placeholder="" v-model="form.groupDesc"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('asm_rework_dialog.fu_jian')">
              <t-upload
                type="file"
                :bizId="form.itemGroupId"
                bizType="asm.service.rewework"
                v-model="textFileList"
                :tip="$t('asm_rework_dialog.znscwordpdfwjqbcg5M')"
                :limit="3"
                ref="reworkFile"
                :autoUpload="false"
              ></t-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="item-title">{{ $t('asm_rework_dialog.fgxxx') }}</div>
      <div>
        <el-table :data="tableList">
          <el-table-column type="index" label="#"></el-table-column>
          <el-table-column min-width="40" :label="$t('asm_rework_dialog.xian_shi_xu_hao')">
            <template slot-scope="scope">
              <el-input :disabled="model.type == 'watch'" type="number" placeholder="" v-model="scope.row.showOrder"></el-input>
            </template>
          </el-table-column>
          <el-table-column min-width="80" :label="$t('asm_rework_dialog.fan_gong_xiang')">
            <template slot-scope="scope">
              <el-input :disabled="model.type == 'watch'" placeholder="" v-model="scope.row.itemName"></el-input>
            </template>
          </el-table-column>
          <el-table-column min-width="80" :label="$t('asm_rework_dialog.bi_fan_xiang')">
            <template slot-scope="scope">
              <el-radio-group :disabled="model.type == 'watch'" v-model="scope.row.isRequired">
                <el-radio :label="1">{{ $t('Common.com_yes') }}</el-radio>
                <el-radio :label="0">{{ $t('Common.com_no') }}</el-radio>
              </el-radio-group>
            </template>
          </el-table-column>
          <el-table-column min-width="80" :label="$t('asm_rework_dialog.ling_jian_wei_zhi')">
            <template slot-scope="scope">
              <custom-select
                :disabled="model.type == 'watch'"
                type="tree"
                :auto="false"
                :data="componentList"
                :show-all-levels="false"
                v-model="scope.row.componentCode"
                :props="{ label: 'componentName', value: 'componentCode', emitPath: false }"
                @treeValChange="onTreeValChange($event, scope.row)"
                :placeholder="$t('Common.com_please_select')"
                width="100%"
              ></custom-select>
            </template>
          </el-table-column>
          <el-table-column min-width="80" property="unitPrice" :label="$t('asm_rework_dialog.ljbhljmc')">
            <template slot-scope="scope">
              <custom-select
                :disabled="model.type == 'watch'"
                url="partList"
                v-model="scope.row.codeName"
                :filterable="true"
                remote
                :listener="scope.row.codeName"
                :params="{ isLimit: true, keyword: scope.row.codeName }"
                :placeholder="$t('Common.com_please_select')"
                :model="scope.row"
                :props="{ label: 'codeName', value: 'codeName', map: { partName: 'partName', partCode: 'partCode', partDesc: 'partDesc', partSpec: 'partSpec' } }"
                width="100%"
              ></custom-select>
            </template>
          </el-table-column>
          <el-table-column min-width="40" :label="$t('asm_rework_dialog.shu_liang')">
            <template slot-scope="scope">
              <el-input :disabled="model.type == 'watch' || scope.row.componentPartCount <= 1" min="1" type="number" placeholder="" v-model="scope.row.partCount"></el-input>
            </template>
          </el-table-column>
          <el-table-column min-width="40" :label="$t('Common.com_handle')" v-if="model.type !== 'watch'">
            <template slot-scope="scope" v-if="model.type !== 'watch'">
              <el-button type="text" size="mini" @click="delItem(scope.$index)">{{ $t('Common.com_delete') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="add-child-btn" @click="addItem()" v-if="model.type !== 'watch'">
          <div style="display: inline-block">
            <i class="icon icon-add"></i>
            <span>{{ $t('asm_rework_dialog.tjxmxx') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer" v-if="model.type !== 'watch'">
      <el-button size="small" @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
      <el-button size="small" type="primary" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
    <div slot="footer" class="dialog-footer" v-else>
      <el-button size="small" type="primary" @click="closeDialog">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import tUpload from '@/components/upload.vue';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  components: { tUpload },
  data() {
    return {
      itemForm: {
        componentCode: '',
        langComponentName: '',
        isRequired: 1,
        itemName: '',
        partCode: '',
        partCount: '',
        componentPartCount: 0,
        partName: '',
        partCodeName: '',
        partSpec: '',
        showOrder: '',
      },
      tableList: [],
      form: {
        itemGroupId: null,
        attachList: [],
        basicItems: [],
        groupDesc: '',
        itemVersion: '',
        productCode: '',
        productSn: '',
        serviceClass: 50,
      },
      componentList: [],
      partList: [],
      textFileList: [],
    };
  },
  computed: {
    rules() {
      return {
        productSn: { required: true, message: this.$t('asm_rework_dialog.qxzcpSN') },
        itemVersion: [
          { required: true, message: this.$t('asm_rework_dialog.qsrbbh') },
          { pattern: /^\d+\.\d+$/, message: this.$t('asm_rework_dialog.bbhgsbzqqcxsrlr1011') },
        ],
      };
    },
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 变更产品SN
    onChangeProduct() {
      this.tableList.forEach((item) => {
        item.componentCode = '';
        item.langComponentName = '';
      });
      this.$nextTick(() => {
        this.componentList = [];
      });
      this.getComponentList();
    },
    // 零件位置下拉
    getComponentList(cb) {
      cb = cb || function () {};
      if (!this.form.productSn) {
        this.componentList = [];
        return;
      }
      this.$getJSON(apis.reworkComponent, { productSn: this.form.productSn }).then((res) => {
        this.componentList = res.data;
        const list = this.$treeTransArray(this.componentList, 'children');
        cb(list);
      });
    },
    // 零件位置选择
    onTreeValChange(arr, row) {
      const name = arr && arr[arr.length - 1] ? arr[arr.length - 1]['langComponentName'] : '';
      const count = arr && arr[arr.length - 1] ? arr[arr.length - 1]['partCount'] : '';
      this.$set(row, 'langComponentName', name);
      this.$set(row, 'componentPartCount', count);
      this.$set(row, 'partName', '');
      this.$set(row, 'partCode', '');
      this.$set(row, 'partDesc', '');
      this.$set(row, 'partSpec', '');
      this.$set(row, 'codeName', '');
      this.$set(row, 'partCount', name ? 1 : '');
    },
    addItem() {
      this.tableList.push(JSON.parse(JSON.stringify(this.itemForm)));
    },
    delItem(index) {
      this.tableList.splice(index, 1);
    },
    // 初始化
    initDialog: function () {
      if (this.model.type === 'edit' || this.model.type === 'watch') {
        this.getItemDetail();
      } else {
        this.addItem();
      }
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
    },
    // 获取详情
    getItemDetail: function () {
      this.$getJSON(apis.reworkItemGroupInfo, { itemGroupId: this.model.row.itemGroupId }).then((res) => {
        const info = res.data;
        this.form.itemGroupId = info.itemGroupId;
        this.form.productSn = info.productSn;
        this.form.productCode = info.productCode;
        this.form.itemVersion = info.itemVersion;
        this.form.groupDesc = info.groupDesc;
        this.getComponentList((arr) => {
          const list = info.items;
          list.forEach((item) => {
            item.codeName = item.partCode ? `${item.partCode}/${item.partName}` : '';
            const row = arr.find((t) => t.componentCode === item.componentCode);
            item.componentPartCount = row ? row.partCount : 0;
          });
          this.tableList = list;
        });
      });
    },
    // 确认保存
    async confirm() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) {
          return;
        }
        const list = this.tableList.filter((t) => t.showOrder && t.itemName);
        if (list.length === 0) {
          this.$message.error(this.$t('asm_rework_dialog.qzstx1tfgxxxbbztxwz'));
          return;
        }
        const list2 = this.tableList.filter((t) => (t.componentCode && !t.partName) || (!t.componentCode && t.partName) || !t.showOrder || !t.itemName);
        if (list2.length) {
          this.$message.error(this.$t('asm_rework_dialog.qzstx1tfgxxxbbztxwz'));
          return;
        }
        // 零件编号不能重复
        const list3 = this.tableList.filter((t) => t.partCode).map((f) => f.partCode);
        const isDiff = list3.length !== [...new Set(list3)].length;
        if (isDiff) {
          this.$message.error(this.$t('asm_rework_dialog.ljbhljmcbncfqcxxz'));
          return;
        }
        // 零件编号不能重复
        const list4 = this.tableList.filter((t) => t.componentCode && t.componentCode !== 'other').map((f) => f.componentCode);
        const isDiff2 = list4.length !== [...new Set(list4)].length;
        if (isDiff2) {
          this.$message.error(this.$t('asm_rework_dialog.ljwzbncfqcxxz'));
          return;
        }
        await Promise.all([this.$refs.reworkFile.submit()]);
        this.form.attachList = this.textFileList;
        if (this.model.type === 'add') {
          this.saveInsert();
        }
        if (this.model.type === 'edit') {
          this.saveUpdate();
        }
      });
    },
    // 保存新增
    saveInsert: function () {
      this.form.basicItems = this.tableList;
      this.$postJSON(apis.reworkItemGroupSave, this.form).then(() => {
        this.$message({
          message: this.$t('Common.com_add_success'),
          type: 'success',
        });
        this.$emit('success');
        this.closeDialog();
      });
    },
    // 保存编辑
    saveUpdate: function () {
      this.form.basicItems = this.tableList;
      this.$postJSON(apis.reworkItemGroupUpdate, this.form).then(() => {
        this.$message({
          message: this.$t('Common.com_edit_success'),
          type: 'success',
        });
        this.$emit('success', this.form);
        this.closeDialog();
      });
    },
  },
};
</script>

<style lang="scss">
.rework-item-dialog {
  .add-child-btn {
    background: rgba(245, 245, 245, 1);
    border: 1px dashed rgba(228, 228, 228, 1);
    line-height: 40px;
    text-align: center;
    color: #333333;
    font-size: 12px;
    margin-top: 10px;
    cursor: pointer;
    .icon {
      color: #00afff;
      font-size: 10px;
      margin-right: 8px;
      float: left;
    }
  }

  .el-form-item {
    width: 100%;
  }

  .el-input-number--small {
    line-height: 30px;
  }

  .mce-edit-area {
    border-top: 0;
  }

  .mce-first {
    display: none;
  }
}
</style>
